module.exports = __webpack_public_path__ + "28918721985ff5654ec1d5ff11f1e0cc.MP3";